<template>
  <v-navigation-drawer
    v-model="drawer"
    mobile-breakpoint="960"
    app
    width="270px"
    class="grey darken-3"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
  >
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-img src="@/assets/img/header.png" />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list dense nav>
      <template v-for="(item, i) in items">
        <sub-item v-if="item.children" :key="`group-${i}`" :item="item" />
        <item v-else :key="`item-${i}`" :item="item" />
      </template>

      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Item from "./Item";
import SubItem from "./SubItem";
import menu from "../services/menu";
import { hasPermission } from "../router";

export default {
  name: "Sidebar",
  components: {
    Item,
    "sub-item": SubItem,
  },
  data() {
    return {
      barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    role() {
      return this.$store.state.auth.userDetail.role;
    },
    items() {
      const perms = this.$store.state.rbac.myPermissions;
      const rbacEnabled = this.$store.state.rbac.rbacEnabled;
      if (!rbacEnabled || !perms || !perms.length) {
        let base = [];
        if (
          this.role === "ROLE_ADMIN" ||
          this.role === "ROLE_FINANCE" ||
          this.role === "ROLE_ACCOUNTING"
        )
          base = menu.admin;
        else if (this.role === "ROLE_MANAGER") base = menu.manager;
        else if (this.role === "ROLE_USER") base = menu.user;
        return this.stripAdminOnly(base);
      }
      return this.filterMenu(menu.admin, perms);
    },
  },
  methods: {
    stripAdminOnly(items) {
      if (this.role === "ROLE_ADMIN" || !items) return items;
      return items
        .filter(item => item.to !== "/setting/rbac")
        .map(item =>
          item.children ? { ...item, children: this.stripAdminOnly(item.children) } : item
        );
    },
    filterMenu(items, permissions) {
      if (!items) return [];
      return items.filter(item => {
        if (item.children) {
          item.children = this.filterMenu(item.children, permissions);
          return item.children.length > 0;
        }
        if (!item.to) return true;
        const fullPrefix = item.to.replace(/^\/+|\/+$/g, "").replace(/\//g, "-");
        const readPerm = fullPrefix + ".read";
        return hasPermission(permissions, readPerm);
      });
    },
  },
};
</script>

<style scoped>
.v-list-item {
  padding: 0 8px !important;
}
</style>
